// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"su_a bhs_rc bhs_qx bhs_xr","ForumPosts__contest":"su_b bhs_hq","ForumPosts__counselling":"su_c"};